export default "__VITE_ASSET__CvX5B8_y__"